"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDiacritics = void 0;
/**
 * Remove diacritics (accents) from a string.
 *
 * Normalize to NFD Unicode normal form decomposes combined graphemes into the combination of simple ones.
 * e.g. 'Crème Brulée': The 'è' of 'Crème' ends up expressed as e +  ̀.
 * Using a regex character class to match the U+0300 → U+036F range, it is now trivial to globally get rid of the
 * diacritics, which the Unicode standard conveniently groups as the Combining Diacritical Marks Unicode block
 * (https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @example removeDiacritics('Crème brulée') → 'Creme brulee'
 * @see https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript#answer-37511463
 */
const removeDiacritics = (str) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
exports.removeDiacritics = removeDiacritics;
//# sourceMappingURL=removeDiacritics.js.map